import React from 'react'
import PropTypes from 'prop-types'
import { Icon, Button } from '@driftt/tide-core-legacy'

import { PlaybookReportType } from 'app/modules/playbook/constants'

import ConfirmModal from 'components/ConfirmModal'
import shinyPlaybookSrc from 'images/shiny-playbook.svg'

import './style.styl'

const EnablePlaybookModal = ({ onClose, open, action, playbook }) => {

  const driftLinkOnly = playbook.targeting.audience === "NONE"
  const isOutboundPlaybook = playbook.reportType === PlaybookReportType.TALK_TO_YOUR_OUTBOUND_PROSPECTS

  return (
    <ConfirmModal open={open} onClose={onClose} className="enable-playbook-modal">
      <header className="enable-playbook-modal-header">
        <div className="enable-playbook-modal-close-icon" onClick={onClose}>
          <Icon name="close" />
        </div>
      </header>

      <div className="enable-playbook-modal-content">
        <div className="enable-playbook-modal-column">
          <h1>Enable Playbook?</h1>
          {isOutboundPlaybook && (
            <div>
              <p>Enabling this <b>Outbound playbook</b> means that we&rsquo;ll automatically greet prospects you email through Drift with a personalized message when they click a link to your site.</p>
              <p>Want more conversations now? Enable it <i><b>now!</b></i></p>
            </div>
          )}
          {!driftLinkOnly && !isOutboundPlaybook && <div>
            <p>Remember to review your <a href={ `playbooks/editor/${playbook.id}/targeting/builder` } target="_blank" rel="noopener nofollower"><strong>targeting conditions</strong></a> before turning this playbook on!</p>
          </div>}
          {driftLinkOnly && <div className="enable-playbook-modal-priority">
            <p>This playbook is set to be triggered only by a DriftLink.</p>
          </div>}
          <div className="enable-playbook-modal-actions">
            <Button onClick={action} type="primary">Enable</Button>
            <Button type="subtle" onClick={onClose}>Cancel</Button>
          </div>
        </div>
        <div className="enable-playbook-modal-column">
          <img src={shinyPlaybookSrc} alt="Shiny new playbook"/>
        </div>
      </div>
    </ConfirmModal>
  )
}

EnablePlaybookModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  action: PropTypes.func.isRequired,
  playbook: PropTypes.object.isRequired,
}

export default EnablePlaybookModal



// WEBPACK FOOTER //
// ./src/scripts/components/PlaybookList/EnablePlaybookModal/index.js